import { TextButton } from '@zillow/constellation-10';
import { ZILLOW_LEASES_HELP } from '../../constants/stringConstants';

export function GetLeaseHelpButton({ onImpact = false }: { onImpact?: boolean }) {
  return (
    <TextButton onImpact={onImpact} asChild>
      <a href={ZILLOW_LEASES_HELP} target="_blank" rel="noopener noreferrer">
        Get lease help
      </a>
    </TextButton>
  );
}
